import { render, staticRenderFns } from "./tfbl.vue?vue&type=template&id=b3cb5bf2&"
import script from "./tfbl.vue?vue&type=script&lang=js&"
export * from "./tfbl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports